import { useContext, useEffect, useState } from "react";
import { KeycloakContext } from "../components/KeycloakProvider";

export function useAccessToken() {
    const { keycloak, initialized, authenticated } = useContext(KeycloakContext);
    const [token, setToken] = useState<string | null>(null);

    useEffect(() => {
        console.log("Keycloak state:", { initialized, authenticated, token: keycloak?.token });
        let cancelled = false;

        const fetchToken = async () => {
            if (initialized && authenticated && keycloak) {
                try {
                    await keycloak.updateToken(30);
                    if (!cancelled) {
                        setToken(keycloak.token ?? null);
                    }
                } catch (err) {
                    if (!cancelled) {
                        setToken(null);
                        keycloak.logout();
                    }
                }
            } else {
                setToken(null);
            }
        };

        fetchToken();

        return () => {
            cancelled = true;
        };
    }, [initialized, authenticated, keycloak]);

    return token;
}